import React from 'react';
import { Box, Typography, AppBar, Toolbar, IconButton, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

function AboutPage() {
  const navigate = useNavigate();
  return (
    <>
      <SEO 
        title="서비스 안내 | 스냅로그"
        description="스냅로그는 독서기록을 남기고 공유할 수 있는 서비스입니다. 제작자 정보와 연락처를 확인하세요."
        url="/about"
      />
      <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
      <AppBar position="static" color="inherit" elevation={0} sx={{ borderBottom: '1px solid #eee', bgcolor: '#fff' }}>
        <Toolbar sx={{ minHeight: 56, px: 2 }}>
          <IconButton edge="start" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1, fontWeight: 700, ml: 1 }}>서비스 안내</Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm" sx={{ mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, mt: 2, color: '#222' }}>SnapLog</Typography>
        <Typography variant="body1" sx={{ color: '#333', mb: 2, textAlign: 'center', fontSize: '1.08rem', lineHeight: 1.7 }}>
          제작자: <b>username_gsh</b><br/>
          이메일: <b>usernamegsh@gmail.com</b>
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mt: 2, textAlign: 'center', fontSize: '1.01rem' }}>
          책 읽고 중요한 내용을 정리하고 싶어서 만들었습니다.<br/>
          필요한 기능이 있다면 언제든 제안해주세요.<br/>
          감사합니다.
        </Typography>
      </Container>
    </Box>
    </>
  );
}

export default AboutPage; 